import { brand } from "@/brandVariables/getBandVariables";
import { Flex, Grid, Text } from "@radix-ui/themes";
import { FC } from "react";

import { leaderboardUsers } from "../../../types/leaderboardUsersResponse";
import { formattedTime } from "../../../helperFunctions/formatMsToTime";
import BaseUserAvatar from "../../reusable/BaseUserAvatar";
import { ClientProps } from "../../../hooks/useClientData";

export const Racing_leaderboard: FC<{ clientData: ClientProps }> = ({
  clientData,
}) => {
  const users = (clientData.leaderboard.data || []).slice(
    0,
    7
  ) as leaderboardUsers[];
  const isElgiganten = brand.client === "elgiganten-9u2oj" ? "elgiganten" : "";

  return (
    <Flex direction={"column"} gap={"3"}>
      <Grid
        className="leaderboard__legend"
        width={"100%"}
        mt={"-2.5rem"}
        columns={{ initial: "3fr 5fr 3fr 3fr" }}
        gap={{
          initial: "var(--leaderboard-gap-sm)",
          md: "var(--leaderboard-gap)",
        }}
      >
        <Text as={"p"} size={"4"}>
          Rank
        </Text>
        <Text as={"p"} size={"4"}>
          Player
        </Text>
        <Text as={"p"} size={"4"}>
          {brand.metaInfo.playerTeamOrCarKey}
        </Text>
        <Text as={"p"} size={"4"}>
          Time
        </Text>
      </Grid>

      {users.map((user) => (
        <li
          key={user.userChallengeData.points || user.profile.userName}
          id={`player-${user.userChallengeData.rank}`}
          className="leaderboard__user"
        >
          <div className="user">
            <span className="user__position background">
              <div className={`background__angle-top-right ${isElgiganten}`} />
              <p>{user.userChallengeData.rank}</p>
            </span>

            <div className="user__info">
              {user.profile.profileLogoUrl &&
                !user.profile.profileLogoUrl.includes("/static") ? (
                <BaseUserAvatar
                  userName={user.profile.userName}
                  logoUrl={user.profile.profileLogoUrl}
                />
              ) : (
                <h5>{user.profile.userName?.[0]}</h5>
              )}
              <div className="user__names">
                <p className="user__name">
                  {user.profile.userName ||
                    user.userChallengeData.inGameUserName}
                </p>
              </div>
            </div>

            <div className="user__team">
              <p>{brand.metaInfo.playerTeamOrCarValue}</p>{" "}
              {/* Or swap in actual value if available */}
            </div>

            <span className="user__score">
              <p>{formattedTime(user.userChallengeData.points) || "-"}</p>
            </span>
          </div>
        </li>
      ))}

      {/* Fill up to 7 slots */}
      {users.length < 7 &&
        Array.from({ length: 7 - users.length }, (_, i) => (
          <li
            key={`placeholder-${i}`}
            className="leaderboard__user placeholder"
          />
        ))}
    </Flex>
  );
};
